import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Box, Flex, Text } from '@chakra-ui/react';

import NoResultsMessage from '../../components/NoResultsMessage';
import Page from '../../components/Page';
import LoadingSpinner from '../../components/Spinner';
import { analyticsIds } from '../../constants/analyticsIds';
import insuredImage from '../../noInsuredsImage.png';
import { setCurrentPage } from '../../redux/modules/app';
import { getCompanyDepartments, selectActiveDepartments, selectCompany } from '../../redux/modules/company';
import { selectUser } from '../../redux/modules/user';

const DepartmentListPage = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const user = useSelector(selectUser);
  const company = useSelector(selectCompany);

  useEffect(() => {
    dispatch(setCurrentPage('list-departments'));
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { dispatch(getCompanyDepartments(params.companyId)); }, []);

  useEffect(() => {
    window.heap.identify(user.userEmail);
    window.heap.addUserProperties({
      name: `${user.userFirstName} ${user.userLastName}`,
      email: user.userEmail,
      phone: user.userPhone,
      userId: user.userId,
      userLevel: user.userLevel,
      pinsVersion: '2.0',
      account: company.companyName,
      companyId: company.companyId,
      companyAddress1: company.companyAddress1,
      companyAddress2: company.companyAddress2,
      companyCity: company.companyCity,
      companyPhone: company.companyPhone
    });
  }, [user, company]);

  const userDepartments = useSelector(selectActiveDepartments);
  const companyDepartments = useSelector(selectActiveDepartments);

  if (!companyDepartments && !companyDepartments?.length && !userDepartments?.length) {
    if (!user || (user && !user.roles.find(role => role.name === 'COMPANY_USER'))) {
      return <LoadingSpinner />;
    }

    return (
      <Page>
        <Flex margin="auto" w="600px">
          <NoResultsMessage
            altTag="No Departments"
            image={insuredImage}
            message={'You don\'t have access to any departments. '
          // eslint-disable-next-line max-len
          + 'If you think this message is an error or you need your permissions changed, please contact the main user on your account.'}
          />
        </Flex>
      </Page>

    );
  }

  return (
    <Page>
      {company && (
        <Flex alignItems="center" flexDirection="column" justifyContent="center" minW="600px" pt={20}>
          <Text mb={2} textStyle="displayXs">
            {`Welcome to PINS, ${user.userFirstName}!`}
          </Text>
          <Text textStyle="bodyXl">
            Select a department to continue
          </Text>
          <Box
            border="1px"
            borderColor="greyScale.900"
            justifyContent="center"
            maxW="80%"
            minW="60%"
            mt={4}
            mx="auto"
          >
            <Box bg="primaryScale.600" py={2}>
              <Text color="white" textStyle="displayXxs">{company?.companyName}</Text>
            </Box>
            {user.userLevel === 1
              ? (
                <>
                  {companyDepartments.map((department, i) => (
                    <Box
                      bg={((i + 1) % 2 === 0) ? 'background.main' : 'white'}
                      key={department.departmentId}
                      py={2}
                    >
                      <Link
                        data-analytics-id={analyticsIds.homePage.selectDepartmentReportButton}
                        dusk={department.departmentName}
                        to={`/companies/${params.companyId}/reports?department_id=${department.departmentId}`}
                      >
                        {department.departmentName}
                      </Link>
                    </Box>
                  ))}
                </>
              ) : (
                <>
                  {userDepartments.map((department, i) => (
                    <Box
                      bg={((i + 1) % 2 === 0) ? 'background.main' : 'white'}
                      key={department.departmentId}
                      py={2}
                    >
                      <Link
                        data-analytics-id={analyticsIds.homePage.selectDepartmentReportButton}
                        dusk={department.departmentName}
                        to={`/companies/${params.companyId}/reports?department_id=${department.departmentId}`}
                      >
                        {department.departmentName}
                      </Link>
                    </Box>
                  ))}
                </>
              )}
          </Box>
        </Flex>
      )}
    </Page>
  );
};

DepartmentListPage.propTypes = {};

export default DepartmentListPage;
